import React, { useEffect, useState } from "react";
import { useHistory, useLocation, useRouteMatch } from "react-router-dom";
import FirstView from "../../Repeated-Component/FirstView";
import AllergiesImage from "../../../../../../../../assets/medical-record/requests/Allergies.png";

import { connect } from "react-redux";
import { getAllergyList } from "../../../../../../../../store/actions";
import { useToast } from "@chakra-ui/react";

const useQuery = () => {
  const { search } = useLocation();
  return React.useMemo(() => new URLSearchParams(search), [search]);
};

const ListingAllergies = ({
  allergy,
  patient,
  getAllergyList,
  AllergyList,
}) => {
  const { url } = useRouteMatch();
  let query = useQuery().get("page");
  const toast = useToast();
  const history = useHistory();

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [Allergy, setAllergy] = useState([]);
  const [filterAllergy, setFilterAllergy] = useState([]);
  const [currentPage, setCuttentPage] = useState(1);
  const [totalResults, setTotalResults] = useState(0);
  const pagesNumber = Math.ceil(totalResults / 15);

  const nextPage = () => {
    const next = currentPage + 1;
    history.push(`${url}?page=${next}`);
  };

  const prevPage = () => {
    const prev = currentPage - 1;
    history.push(`${url}?page=${prev}`);
  };

  const specificPage = (pageNum) => {
    history.push(`${url}?page=${pageNum}`);
  };

  useEffect(() => {
    getAllergyList(toast, history, patient.id, query);
  }, [getAllergyList, query]);

  useEffect(() => {
    if (AllergyList) {
      const { loading, error, data } = AllergyList;
      setLoading(loading);
      setError(error);
      if (data) {
        setAllergy(data.data);
        setFilterAllergy(data.data);
        setTotalResults(data.meta.total);
        setCuttentPage(data.meta.current_page);
      }
    }
  }, [AllergyList]);
  return (
    <div>
      <FirstView
        loading={loading}
        error={error}
        headerName="Allergies"
        buttonLink={`${url}/request-allergies`}
        cardLink={`${url}/view-allergies`}
        data={Allergy}
        filterData={filterAllergy}
        setFilter={setFilterAllergy}
        conditionImage={AllergiesImage}
        pages={pagesNumber}
        nextPage={nextPage}
        prevPage={prevPage}
        specificPage={specificPage}
        currentPage={currentPage}
        totalResults={totalResults}
      />
    </div>
  );
};
const mapStateToProps = (state) => {
  return {
    AllergyList: state.AllergyList,
  };
};
export default connect(mapStateToProps, { getAllergyList })(ListingAllergies);
